import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { sessionStore } from '../Session/Store';

import type { JSX } from 'react';

interface WhenImpersonatingProps {
  children: JSX.Element | ((impersonator: string) => JSX.Element);
}

function WhenImpersonating({ children }: WhenImpersonatingProps) {
  return sessionStore.impersonatingBy
    .map((name) => (typeof children === 'function' ? children(name) : children))
    .getOrElse(emptyFragment);
}

export default observer(WhenImpersonating);
